/* ============================================================================
   TFMC · Brand film — reveal and play.

   Loaded deferred and external from sections/tfmc-film.liquid. It touches
   nothing outside its own [data-tfmc-film] frame: no Loop DOM, no hidden
   input, no hydration gate, no theme component.

   The <video> ships in the markup with preload="none", hidden, and with native
   controls already on. This script is what reveals it: the poster, the round
   control and the time badge step out of the way and playback starts on the
   click that revealed them. The native controls then run the film, so nothing
   below has to reimplement scrubbing, volume or fullscreen.

   If the script never runs the control does nothing and the film cannot be
   played — the button is not a link and there is no CSS-only reveal. That is
   stated rather than worked around: the asset is a small deferred file served
   from the shop's own origin, and a page that cannot fetch it has larger
   problems. Do not write "degrades gracefully" here; an earlier version of this
   comment claimed it did and was wrong.

   Idempotent: a second execution re-binds nothing, because every frame is
   marked once it is wired.
   ========================================================================== */
(function () {
  var MARK = 'tfmcFilmBound';

  function wire(frame) {
    if (frame.dataset[MARK]) return;
    frame.dataset[MARK] = '1';

    var button = frame.querySelector('[data-tfmc-film-play]');
    var video = frame.querySelector('video');
    if (!button || !video) return;

    button.addEventListener('click', function () {
      video.hidden = false;

      // Hide the poster furniture only once the video is actually showing, so
      // a rejected play() never leaves a blank frame with no way back.
      var done = function () {
        button.hidden = true;
        var poster = frame.querySelector('.d3-film__poster');
        if (poster) poster.hidden = true;
        var time = frame.querySelector('[data-tfmc-film-time]');
        if (time) time.hidden = true;
      };

      var played = video.play();
      if (played && typeof played.then === 'function') {
        played.then(done).catch(function () {
          // Autoplay policies can refuse a programmatic play in some contexts.
          // The video is visible and carries its own controls, so leave it.
          done();
        });
      } else {
        done();
      }
    });
  }

  function init() {
    var frames = document.querySelectorAll('[data-tfmc-film]');
    for (var i = 0; i < frames.length; i++) wire(frames[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders a section into the DOM without a page load.
  document.addEventListener('shopify:section:load', init);
})();
